import { useGetCompanyById } from '@sit/client-shared';
import { useCompanyTreeSettingsIdInPathParams } from '../helpers';
import { CompanyEntitiesTable } from './CompanyEntitiesTable';

export function CompanyEntitiesPage() {
  const companyTreeSettingsId = useCompanyTreeSettingsIdInPathParams();
  const { data: company, isLoading } = useGetCompanyById({
    companyTreeSettingsId,
  });

  if (isLoading || !company) {
    return <div>Loading...</div>;
  }

  return <CompanyEntitiesTable entities={company.entities} />;
}
